import { useEffect, useMemo } from "react";

export const useFormDefaultValues = (reset, getDefaultValues, watchValues) => {
  const values = getDefaultValues();
  const defaultValues = useMemo(() => values, watchValues);
  useEffect(() => {
    reset(defaultValues);
  }, [reset, defaultValues]);
};
